<template>
<el-dialog
    class="copy-dialog"
    :title="'标书复制'"
    :visible.sync="showCopyDialog"
    width="1000px"
    :close-on-click-modal="true"
    :before-close="handleVisible"
    height="500px">
    <el-form ref="formbid" :model="form" :rules="rules" size="mini">
        <div class="bid-info">标书信息</div>
        <div class="form-box">
            <div class="content-box-item content-box-s0">
                <div class="notice_title"><span class="xing">*</span>标书名称：</div>
                <el-form-item prop="bidName" class="tab-width">
                    <el-input
                        v-model.trim="form.bidName"
                        placeholder="标书名称"
                        class="tab-width"
                        size="mini">
                    </el-input>
                </el-form-item>
            </div>
            <div class="content-box-item content-box-s0">
                <div class="notice_title"><span class="xing">*</span>保证金截止时间：</div>
                <el-form-item prop="depositEndTime" class="tab-width">
                    <el-date-picker
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptionsStart"
                        v-model="form.depositEndTime"
                        type="datetime"
                        placeholder="0000-00-00 00:00">
                    </el-date-picker>
                </el-form-item>
            </div>
            <div class="content-box-item content-box-s0">
                <div class="notice_title"><span class="xing">*</span>报名截止时间：</div>
                <el-form-item prop="signUpEndTime" class="tab-width">
                    <el-date-picker
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptionsStart"
                        v-model="form.signUpEndTime"
                        type="datetime"
                        placeholder="0000-00-00 00:00">
                    </el-date-picker>
                </el-form-item>
            </div>
            <div class="content-box-item content-box-s0">
                <div class="notice_title"><span class="xing">*</span>报价开始时间：</div>
                <el-form-item prop="quoteStartTime" class="tab-width">
                    <el-date-picker
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptionsStart"
                        v-model="form.quoteStartTime"
                        type="datetime"
                        placeholder="0000-00-00 00:00">
                    </el-date-picker>
                </el-form-item>
            </div>
            <div class="content-box-item content-box-s0">
                <div class="notice_title"><span class="xing">*</span>标书购买开始时间：</div>
                <el-form-item prop="purchaseStartTime" class="tab-width">
                    <el-date-picker
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptionsStart"
                        v-model="form.purchaseStartTime"
                        type="datetime"
                        placeholder="0000-00-00 00:00">
                    </el-date-picker>
                </el-form-item>
            </div>
            <div class="content-box-item content-box-s0">
                <div class="notice_title"><span class="xing">*</span>招标方式：</div>
                <el-form-item prop="bidType" class="tab-width">
                    <MSelect
                        :optionArr="SU_BID_TYPE"
                        :value="form.bidType"
                        :filterable="true"
                        @input="getbidType">
                    </MSelect>
                </el-form-item>
            </div>
            <div class="content-box-item content-box-s0">
                <div class="notice_title"><span class="xing">*</span>是否重新方案审批：</div>
                <el-form-item prop="reexamination" class="tab-width">
                    <MSelect
                        :optionNum="'SRM_YES_NO'"
                        :value="form.reexamination"
                        :filterable="true"
                        @input="getreexamination">
                    </MSelect>
                </el-form-item>
            </div>
        </div>
        <div class="bid-info">复制范围</div>
        <el-checkbox-group v-model="checkList" style="padding-left:10px;" @change="checkListChange">
            <el-checkbox label="标书文件" :disabled="form.reexamination === '0'"></el-checkbox>
            <el-checkbox label="组织成员"></el-checkbox>
            <el-checkbox label="报价模板" :disabled="form.reexamination === '0'"></el-checkbox>
            <el-checkbox label="综合评分模板" v-show="formParent.syntheticalScore==='Y'" :disabled="form.reexamination === '0'"></el-checkbox>
            <el-checkbox label="供应商应标状态" :disabled="form.reexamination === '1'"></el-checkbox>
        </el-checkbox-group>
        <div v-if="checkList.indexOf('报价模板') > -1" class="bid-info" style="margin-top:20px;">报价模板</div>
        <el-checkbox-group v-if="checkList.indexOf('报价模板') > -1" v-model="checkExtStrsList" style="padding-left:10px;">
            <el-checkbox v-for="(el,i) in extStrsList" :key="i" :label="el"></el-checkbox>
        </el-checkbox-group>

    </el-form>
    <div slot="footer">
        <el-button @click="handleVisible">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="handleSubmit">确 定</el-button>
    </div>
</el-dialog>
</template>

<script>
import MSelect from '@/components/lots/otpSelect2';
import { copyBidHead, getExtStrsByBidNo } from '../../../../../../lsrm/api/bidScheme.js';

export default {
    props: {
        showCopyDialog: {
            type: Boolean,
            default() {
                return false;
            }
        },
        formParent: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    components: { MSelect },
    data() {
        return {
            rules: {
                bidName: [
                    { required: true, trigger: 'change', message: '请输入标书名称' },
                    { max: 128, message: '标书名称不能超过128个字符', trigger: 'blur' }
                ],
                depositEndTime: [
                    { required: true, trigger: 'change', message: '请选择保证金截止时间' }
                ],
                signUpEndTime: [
                    { required: true, trigger: 'change', message: '请选择报名截止时间' }
                ],
                quoteStartTime: [
                    { required: true, trigger: 'change', message: '请选择报价开始时间' }
                ],
                purchaseStartTime: [
                    { required: true, trigger: 'change', message: '请选择标书购买开始时间' }
                ],
                bidType: [
                    { required: true, trigger: 'change', message: '请选择招标方式' }
                ],
                reexamination: [
                    { required: true, trigger: 'change', message: '请选择方案审批' }
                ]
            },
            loading: false,
            isRequest: true,
            form: {},
            checkList: [],
            extStrsList: [], // 标段列表
            checkExtStrsList: [], // 标段勾选列表
            pickerOptionsStart: { disabledDate: time => { return time.getTime() < new Date(new Date().toLocaleDateString()).getTime(); } },
            SU_BID_TYPE: [
                { value:'10', label:'邀请招标(一对多线上竞价)' },
                { value:'20', label:'公开招标' },
            ],
        };
    },
    methods: {
        handleVisible() {
            this.$emit('update:showCopyDialog', false);
        },
        handleSubmit() {
            this.$refs['formbid'].validate(res => {
                if (res) {
                    this.loading = true;
                    const keywordList = ['needBidModuleFile', 'needBidTeam', 'needBidTemplate', 'needBidCompositeScore', 'needBidSupplier'];
                    const tallTextList = ['标书文件', '组织成员', '报价模板', '综合评分模板', '供应商应标状态'];
                    keywordList.forEach((el, i) => {
                        this.setRange(el, tallTextList[i]);
                    });
                    const a = {
                        ...this.form,
                        bidNo: this.formParent.bidNo,
                        sectionList: this.checkExtStrsList
                    };
                    copyBidHead(a).then(res => {
                        if (res && res.code === '0') {
                            this.loading = false;
                            this.$message.success('标书复制成功！');
                            this.$emit('update:showCopyDialog', false);
                        }
                    });
                } else {
                    this.$message.warning('请完善标书信息！');
                }
            });
        },
        setRange(keyword, val) {
            const status = this.checkList.indexOf(val) > -1 ? '1' : '0';
            this.$set(this.form, keyword, status);
        },
        getbidType(val) {
            this.$set(this.form, 'bidType', val);
        },
        getreexamination(val) {
            this.$set(this.form, 'reexamination', val);
            this.checkStatus(val);
            this.isRequest && this.getQuotationTemplateList();
        },
        // 是否审批控制checkout的状态
        checkStatus(val) {
            if (val === '1') { // 1 是否审批 1是
                const index = this.checkList.findIndex(el => {
                    return el === '供应商应标状态';
                });
                if (index > -1) {
                    this.checkList.splice(index, 1);
                }
            } else {
                const arr = ['标书文件', '报价模板'];
                if (this.formParent.syntheticalScore === 'Y') {
                    arr.push('综合评分模板');
                }
                this.checkList = this.checkList.concat(arr);
                this.checkList = [...new Set(this.checkList)];
            }
        },
        getQuotationTemplateList() {
            this.isRequest = false;
            getExtStrsByBidNo(this.formParent.bidNo).then(res => {
                if (res && res.code === '0') {
                    this.extStrsList = res.data;
                    this.checkExtStrsList = [...res.data];
                }
            });
        },
        checkListChange(val) {
            this.isRequest && this.getQuotationTemplateList();
        }
    }
};
</script>

<style lang="less">
.copy-dialog {
    font-size: 12px;
    min-height: calc(~"100vh - 60px");
    .bid-info {
        font-weight: 700;
        margin-bottom: 12px;
        font-size: 14px;
    }
    .title {
        font-size: 14px;
        font-weight: 700;
    }
    .title-btn {
        display: flex;
        justify-content: space-between;
    }
    .form-box{
        display: flex;
        flex-wrap: wrap;
        justify-content:flex-start;
    }
    .tab-width {
        width: 180px;
    }
    .tab-width1 {
        width: 480px;
    }
    .content-box-item {
        width: 100%;
        display: flex;
        align-items: center;
        flex: 0 1 300px;
    }
    .mselect {
        margin-bottom: 18px;
    }
    .notice_title {
        font-size: 12px;
        flex-shrink: 0;
        margin-bottom: 18px;
        width: 120px;
        display: flex;
        justify-content: flex-end;
    }
    .el-select{
        width: 180px !important;
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner{
        width: 180px !important;
    }
    .table-file {
        padding: 20px;
    }
    .table-file1 {
        padding:20px 20px 0 20px;
    }
    .top-btn {
        display: flex;
        justify-content: flex-end;
        padding-right: 10px;
    }
    .xing {
        color: red;
    }
}

</style>